{
	"Subtype_Aura": "Aura",
	"Subtype_Background": "Background",
	"Subtype_Cartouche": "Cartouche",
	"Subtype_Class": "Class",
	"Subtype_Curse": "Curse",
	"Subtype_Role": "Role",
	"Subtype_Rune": "Rune",
	"Subtype_Saga": "Saga",
	"Subtype_Shard": "Shard",
	"Subtype_Shrine": "Shrine"
}